import { Box, BoxProps } from '@mui/material';

export default function HStack(props: BoxProps) {
  return <Box display="flex" alignItems="center" {...props} />;
}
